import classNames from 'classnames';
import { OverlayLayout } from 'components.layouts/overlay/overlay.js';
import { ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IRepoState } from 'redux-state/rootReducer.js';
import { getDocument } from 'utilities/window.js';

export const OverlayContainer = ({ children }: { children?: ReactNode }) => {
  const overlayOpen = useSelector((state: IRepoState) => state.APP.overlayOpen);

  useEffect(() => {
    getDocument()?.querySelector?.('.InitialPageLoader')?.classList?.remove?.('InitialPageLoader');
  }, []);

  return (
    <>
      <OverlayLayout />
      <div className={classNames('App', { 'has-overlay': overlayOpen }, { DebugMode: false })}>{children}</div>
    </>
  );
};
